import styled from 'styled-components'
import themeGet from '@styled-system/theme-get'

export const Container = styled.div`
  width: 100%;

  .swiper {
    position: relative;
    padding: 0 ${themeGet('space.7')}px ${themeGet('space.13')}px;
  }

  .swiper-pagination-bullet-active {
    background-color: ${themeGet('colors.primary.main')};
  }

  .swiper-slide {
    height: unset;
    flex-grow: 1;
    display: flex;
    justify-content: center;
  }
`
